/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ActiveInvestmentRequestsCheckPayload
 */
export interface ActiveInvestmentRequestsCheckPayload {
    /**
     * 
     * @type {Array<string>}
     * @memberof ActiveInvestmentRequestsCheckPayload
     */
    accountGuids: Array<string>;
}

/**
 * Check if a given object implements the ActiveInvestmentRequestsCheckPayload interface.
 */
export function instanceOfActiveInvestmentRequestsCheckPayload(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "accountGuids" in value;

    return isInstance;
}

export function ActiveInvestmentRequestsCheckPayloadFromJSON(json: any): ActiveInvestmentRequestsCheckPayload {
    return ActiveInvestmentRequestsCheckPayloadFromJSONTyped(json, false);
}

export function ActiveInvestmentRequestsCheckPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActiveInvestmentRequestsCheckPayload {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accountGuids': json['account_guids'],
    };
}

export function ActiveInvestmentRequestsCheckPayloadToJSON(value?: ActiveInvestmentRequestsCheckPayload | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account_guids': value.accountGuids,
    };
}

